export { OfferBox } from './OfferBox';
export type { Offer, OffersColor } from './OfferBox';
